interface Vet {
    vet_id: number,
    user_id: number,
    name: string
    email: string,
    password: string,
    confirmation: string,
    type: string,
    phone: string,
    account_token: string,
    discount: number
}

interface vetSpecialty {
    new: number,
    specialty_pos: number,
    vet_id: number,
    specialty_id: number,
    name: string,
}

interface vetToken {
    vet_id: number,
    account_token: string
}

/* New version - weekly based */

/*interface VetAurinkoProfile {
    vet_id: number,
    week_nr: number,
    week: string,
    date_start: string,
    date_end: string,
    aurinko_profile_id: number
}
*/

/* Old version - monthly based
interface VetAurinkoProfile {
    vet_id: number,
    month_nr: number,
    month: string,
    aurinko_profile_id: number
}
*/

/* Newest version - unique profile */
interface VetAurinkoProfile {
    vet_id: number,
    aurinko_profile_id: number
}

interface WorkingInterval {
    start: string,
    end: string
}

interface DayAvailability {
    date: string,
    name: string,
    hours: WorkingInterval[]
}

interface AvailabilityWeek {
    number: number,
    date_start: string,
    date_end: string,
    week_availability: DayAvailability[]  
}

interface DaySchedule {
    dayOfWeek: string,
    workingIntervals: WorkingInterval[]
}

interface AvailabilityInterval {
    dateStartInclusive: string,
    dateEndInclusive: string,
    hours : WorkingInterval[]
}

interface AvailabilityConfig {
    id: number,
    name: string,
    durationMinutes: number,
    availabilityStep: number,
    timeAvailableFor: string,
    subject: string,
    description: string,
    location: string,
    workHours:
    {
        timezone: string,
        daySchedules: DaySchedule[],
    },
    availabilityIntervals:
    {
        intervals: AvailabilityInterval[]
    },
    context: string,
    startConference: boolean
}

interface createVetAvailabilityProfileParams {
    vet_id: number,
    id: number,
    name: string,
    durationMinutes: number,
    availabilityStep: number,
    timeAvailableFor: string,
    subject: string,
    description: string,
    location: string,
    workHours:
    {
        timezone: string,
        daySchedules: DaySchedule[],
    },
    context: string,
    startConference: boolean
}

interface IniVetAppointmentsParams {
    vetId: number,
    language: string
}

interface VetAppointment {
    appointment_id: number,
    schedule: string,
    customer_user_id: number,
    customer_name: string,
    pet_id: number,
    pet_name: string,
    vet_user_id: number,
    description: string,
    price: number,
    customer_pin: number,
    vet_pin: number,
    appointment_status: string,
    status_date: string
}

const vetResetState = () => ({
    editedVetData: {
        vet_id: 0,
        user_id: 0,
        name: '',
        email: '',
        password: '',
        confirmation: '',
        type: 'vet',
        phone: '',
        account_token: '',
        discount: 0
    },
    aurinkoProfiles: [] as VetAurinkoProfile[],
    editingVet: false,
    vetMode: 'availabilityconfig',
    hasAssociatedCalendar: false,
    vetRecord: [] as VetAppointment [],
    availableVetsUserIDs: [] as number [],
    editedVetSpecialties: [] as vetSpecialty[],
    editedVetNewSpecialtyData:
    {
        new: 1,
        specialty_pos: 0,
        vet_id: 0,
        specialty_id: 0,
        name: ''
    },
    editingVetSpecialty: false,
    editedVetSpecialtiesToBeDeleted: [] as number[],
});

export const editedVet = {
    state: vetResetState(),

    getters: {

        getEditedVetData(state: any): Vet {
            return (state.editedVetData)
        },
        getEditedVetSpecialties(state: any): vetSpecialty[] {
            return (state.editedVetSpecialties)
        },
        getEditedVetNewSpecialtyData(state: any): vetSpecialty {
            return (state.editedVetNewSpecialtyData)
        },
        getEditedVetSpecialtiesToDelete(state: any): number[] {
            return (state.editedVetSpecialtiesToBeDeleted)
        },
        getAurinkoProfiles(state: any): Vet {
            return (state.aurinkoProfiles)
        },
        getEditingVet(state: any): boolean {
            return (state.editingVet)
        },
        getVetMode(state: any): string {
            return (state.vetMode)
        },
        getHasAssociatedCalendar(state: any): boolean {
            return (state.hasAssociatedCalendar)
        },
        getVetRecord(state: any): VetAppointment[] {
            return (state.vetRecord)
        },
        getAvailableVetsUserIDs(state: any): number[] {
            return (state.availableVetsUserIDs)
        }
    },
    mutations: {

        setEditedUserData(state: any, editedUserData: any) {
            state.editedVetData.user_id = editedUserData.user_id;
            state.editedVetData.email = editedUserData.email;
            state.editedVetData.name = editedUserData.name;
            state.editedVetData.vet_id = editedUserData.vet_id;
            state.editedVetData.phone = editedUserData.phone;
            state.editedVetData.account_token = editedUserData.account_token;
            state.editedVetData.discount = editedUserData.discount;
        },

        setEditedVetData(state: any, editedVetData: any) {
            state.editedVetData = editedVetData
        },

        setEditedVetSpecialtiesData(state: any, editedVetSpecialtiesData: any) {
            console.log("setEditedVetSpecialtiesData");
            console.log(editedVetSpecialtiesData);

            state.editedVetSpecialties = [];

            // Process each specialty and assign a position
            editedVetSpecialtiesData.forEach((vetSpecialty: vetSpecialty, index: number) => {
                vetSpecialty.specialty_pos = index;
                vetSpecialty.new = 0; // Mark as not new
                console.log(vetSpecialty);
                state.editedVetSpecialties.push(vetSpecialty);
            });
            
        },

        setEditedVetAddSpecialty(state: any, newSpecialty: any) {
            newSpecialty.specialty_pos = state.editedVetSpecialties.length
            state.editedVetSpecialties.push(newSpecialty)
        },

        setEditedVetRemoveSpecialty(state: any, specialty_pos: number) {
            console.log("setEditedVetRemoveSpecialty")
            state.editedVetSpecialties.splice(specialty_pos, 1)
            state.editedVetSpecialties.forEach((vetSpecialty: any, index: number) => {
                vetSpecialty.specialty_pos = index;
            })
        },

        setEditedVetIniSpecialty(state: any) {
            state.editedVetNewSpecialtyData = {
                new: 1,
                specialty_pos: 0,
                vet_id: 0,
                specialty_id: 0,
                name: ''
            }
        },

        setEditedVetNewSpecialtyData(state: any, newSpecialty: vetSpecialty) {
            state.editedVetNewSpecialtyData.vet_id = newSpecialty.vet_id
            state.editedVetNewSpecialtyData.specialty_id = newSpecialty.specialty_id
            state.editedVetNewSpecialtyData.name = newSpecialty.name
        },

        setEditedVetSpecialtiesToDelete(state: any, specialtiesToDelete: number[]) {
            state.editedVetSpecialtiesToBeDeleted = specialtiesToDelete
        },

        setEditedVetAddSpecialtyIdToDelete(state: any, specialtyId: number) {
            state.editedVetSpecialtiesToBeDeleted.push(specialtyId)
        },

        setAurinkoProfiles(state: any, aurinkoProfiles: VetAurinkoProfile[]) {
            state.aurinkoProfiles = aurinkoProfiles
        },
        setEditingVet(state: any, editingVet: boolean) {
            state.editingVet = editingVet
        },
        setVetMode(state: any, newVetMode: string) {
            state.vetMode = newVetMode
        },
        setHasAssociatedCalendar(state: any, hasAssociatedCalendar: boolean) {
            state.hasAssociatedCalendar = hasAssociatedCalendar
        },
        setVetRecord(state: any, vetRecord: VetAppointment[]) {
            console.log("setVetRecord");
            console.log(vetRecord);
            console.log(typeof (vetRecord));
            state.vetRecord = [];
            vetRecord.forEach((vetrecord: any) => {
                console.log(vetrecord);
                state.vetRecord.push(vetrecord)
            });
        },
        vetResetStateMut(state: any) {
            Object.assign(state, vetResetState())
        },
        setAvailableVetsUserIDs(state: any, availVetsUserIDs: number[]) {
            console.log("setAvailableVetsUserIDs");
            console.log(availVetsUserIDs);
            console.log(typeof (availVetsUserIDs));
            state.availableVetsUserIDs = [];
            availVetsUserIDs.forEach((vetUserID: any) => {
                console.log(vetUserID);
                state.availableVetsUserIDs.push(vetUserID)
            });
        },
    },
    actions: {

        addSpecialtyEditedVet(state: any, newSpecialty: vetSpecialty) {

            newSpecialty.new = 1
            console.log(newSpecialty)
            state.commit('setEditedVetAddSpecialty', newSpecialty)

        },

        saveVetSpecialtyToBeDeleted(state: any, specialtyId: number) {
            console.log(specialtyId)
            state.commit('setEditedVetAddSpecialtyIdToDelete', specialtyId)
        },

        removeSpecialtyEditedVet(state: any, specialty_pos: number) {
            console.log(specialty_pos)
            state.commit('setEditedVetRemoveSpecialty', specialty_pos)
        },

        iniEditedVetNewSpecialty(state: any) {
            state.commit('setEditedVetIniSpecialty')
        },

        updateVetNewSpecialtyData(state: any, selectedSpecialty: File)
        {
            console.log("updateVetNewSpecialtyData")
            console.log(selectedSpecialty)
            state.commit('setEditedVetNewSpecialtyData', selectedSpecialty)
            
        },

        /* Old version

        async iniEditedVet(state: any, vetEmail: string) {

            console.log("iniEditedVet")

            try {
                const response = await fetch(process.env.BASE_URL + `api/users/vet/byemail/${vetEmail}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${state.getters.token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch vet data');
                }

                const vetData = await response.json();
                console.log(vetData);
                console.log(vetData.user_id);
                state.commit('setEditedVetData', vetData);
                console.log(vetData.email);
                 
                // Only call fetchVetAurinkoProfiles if the vet has an account token / an associated calendar 
                if(vetData.account_token === "" || vetData.account_token === null)
                {
                    state.commit('setHasAssociatedCalendar', false);
                }
                else
                {
                    // Call fetchVetAurinkoProfiles with vetId
                    state.commit('setHasAssociatedCalendar', true);
                    await state.dispatch('fetchVetAurinkoProfiles', vetData.vet_id);
                }

                return vetData; // Resolve the promise with the fetched vet data

            } catch (error) {
                console.error('Error fetching vet data:', error);
                throw error; // Re-throw the error to be caught by the caller
            }

        },
        */

        // Action: Initialize vet editing and fetch profiles if applicable
        async iniEditedVet(state: any, vetEmail: string)
        {
            try {
                const vetData = await state.dispatch('iniEditedVetData', vetEmail);

                if (!vetData.account_token) {
                    state.commit('setHasAssociatedCalendar', false);
                } else {
                    state.commit('setHasAssociatedCalendar', true);
                    await state.dispatch('fetchVetAurinkoProfiles', vetData.vet_id);
                }

                return vetData;

            } catch (error) {
                console.error('Error initializing vet edit:', error);
                throw error;
            }
        },
      
        // Action: Fetch vet data and set it as edited vet data
        async iniEditedVetData(state: any, vetEmail: string)
        {
            try {
                const response = await fetch(`${process.env.BASE_URL}api/users/vet/byemail/${vetEmail}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${state.getters.token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch vet data');
                }

                const vetData = await response.json();
                state.commit('setEditedVetData', vetData);
                return vetData;

            } catch (error) {
                console.error('Error fetching vet data:', error);
                throw error;
            }
        },



        async iniEditedVetSpecialties(state: any, vetId: number) {

            console.log("iniEditedVetSpecialties");
            console.log(vetId);
            console.log(process.env.BASE_URL + `api/vets/specialties/` + vetId.toString());
            

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/specialties/` + vetId.toString(),
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then(async (res) => {
                        if (!res.ok) {
                            throw new Error(`HTTP error! Status: ${res.status}`);
                        }
                        return res.json();
                    })
                    .then((vetSpecialtiesData) => {
                        console.log("Received vet specialties:", vetSpecialtiesData);
                        
                        // Store the data in Vuex
                        state.commit('setEditedVetSpecialtiesData', vetSpecialtiesData);
                        resolve(vetSpecialtiesData);
                    })
                    .catch(err => {
                        console.error("Error fetching vet specialties:", err);
                        reject(err);
                    });
            }))

        },


        async createEditedVetSpecialty(state: any, payload: { vetId: number; specialtyId: number }) {
            
            console.log("createEditedVetSpecialty");
            const { vetId, specialtyId } = payload;
            

            const response = await fetch(process.env.BASE_URL + `api/vets/specialty/` + vetId.toString() + `/` + specialtyId.toString(), {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
            })
            if (!response.ok) {
                throw new Error('error_creating_new_specialty')
            }
        },

        async deleteEditedVetSpecialty(state: any, payload: { vetId: number; specialtyId: number }) {
            
            const { vetId, specialtyId } = payload;
            console.log(specialtyId)
            const response = await fetch(process.env.BASE_URL + `api/vets/specialty/` + vetId.toString()+ `/`+ specialtyId.toString(), {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            })
            if (!response.ok) {
                throw new Error('error_deleting_specialty')
            }
        },

        resetVetSpecialties(state: any) {
            state.commit('setEditedVetSpecialtiesData', [])
        },


        async fetchVetAurinkoProfiles(state: any, vetId: string) {

            console.log("fetchVetAurinkoProfiles");

            try {
                const response = await fetch(process.env.BASE_URL + `api/vets/aurinkoprofiles/${vetId}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${state.getters.token}`,
                    }
                });
        
                if (!response.ok) {
                    throw new Error(`Failed to fetch aurinko profiles for vet ID ${vetId}`);
                }
        
                const aurinkoProfiles = await response.json();
                state.commit('setAurinkoProfiles', aurinkoProfiles);
                return aurinkoProfiles;
            } catch (error) {
                console.error('Error fetching Aurinko profiles:', error);
                throw error;
            }
        },

        async iniVetDetailing(state: any, vetData: any) {

            console.log("iniVetDetailing")

            console.log(vetData);
            console.log(vetData.user_id);
            state.commit('setEditedUserData', vetData)
        },


        iniVetEditing(state: any) {

            state.commit('setEditingVet', true);
        },

        endVetEditing(state: any) {

            state.commit('setEditingVet', false);
            state.commit('setEditedVetSpecialtiesToDelete', [])
        
        },

        async editVet(state: any, editedVetData: Vet) {
            console.log(JSON.stringify(editedVetData))
            const response = await fetch(process.env.BASE_URL + `api/users/vet/` + editedVetData.user_id.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: JSON.stringify(editedVetData),
            })

            var editedVetUserId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetUserId = resjson.user_id

            } else {
                throw new Error('error_updating_vet')
            }
            return (editedVetUserId)
        },

        async updateVetToken(state: any, vetTokenData: vetToken) {
            console.log(JSON.stringify(vetTokenData))
            const response = await fetch(process.env.BASE_URL + `api/vets/token/` + vetTokenData.vet_id.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: JSON.stringify(vetTokenData),
            })

            var editedVetId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetId = resjson.vet_id

            } else {
                throw new Error('error_updating_token')
            }
            return (editedVetId)
        },

        async removeVetCalendarAssociation(state: any, vetId: number) {
            console.log(vetId)
            const response = await fetch(process.env.BASE_URL + `api/vets/removecalendarassociation/` + vetId.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
            })

            var editedVetId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetId = resjson.vet_id

            } else {
                throw new Error('error_removing_token')
            }
            return (editedVetId)
        },

        

        iniVetAvailabilityConfig(state: any) {
            state.commit('setVetMode', "availabilityconfig");
        },

        iniVetAvailabilitySlots(state: any) {
            state.commit('setVetMode', "availabilityslots");
        },

        iniVetCustomers(state: any) {
            state.commit('setVetMode', "customers");
        },
        iniVetAppointments(state: any) {
            state.commit('setVetMode', "appointments");
        },
        async iniVetRecord(state : any, params : IniVetAppointmentsParams) {
            console.log("iniVetRecord");
            console.log(params.vetId);
            console.log(params.language);
            console.log(process.env.BASE_URL + `api/vets/record/` + params.vetId.toString( ) + '/' + params.language);

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/record/` + params.vetId.toString( ) + '/' + params.language,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_record_data) => {
                        console.log(vet_record_data);
                        console.log(typeof (vet_record_data));
                        state.commit('setVetRecord', vet_record_data)
                        resolve(vet_record_data)
                    })
                    .catch(err => reject(err))
            }))
        },
        async fetchAvailableVetsUserIDs(state : any, date : string) {
            console.log("fetchAvailableVetsUserIDs");
            console.log(date);
            
            // Remove hyphens from the date string
            const urlSafeDate = date.replace(/-/g, '');

            console.log(process.env.BASE_URL + `api/vets/withavailability/` + urlSafeDate);

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/withavailability/` + urlSafeDate,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_user_ids_data) => {
                        console.log(vet_user_ids_data);
                        console.log(typeof (vet_user_ids_data));
                        state.commit('setAvailableVetsUserIDs', vet_user_ids_data)
                        resolve(vet_user_ids_data)
                    })
                    .catch(err => reject(err))
            }))
        },
        
        async fetchAvailableSpecialistsUserIDs(state : any, payload: { date : string; specialtyId: number }) {
            console.log("fetchAvailableSpecialistsUserIDs");
            const { date, specialtyId } = payload;
            
            console.log(date);
            
            // Remove hyphens from the date string
            const urlSafeDate = date.replace(/-/g, '');

            console.log(process.env.BASE_URL + `api/vets/specialists/withavailability/` + urlSafeDate + '/' + specialtyId.toString( ));

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/specialists/withavailability/` + urlSafeDate + '/' + specialtyId.toString( ),
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_user_ids_data) => {
                        console.log(vet_user_ids_data);
                        console.log(typeof (vet_user_ids_data));
                        state.commit('setAvailableVetsUserIDs', vet_user_ids_data)
                        resolve(vet_user_ids_data)
                    })
                    .catch(err => reject(err))
            }))
        },
        
        async fetchSpecialistsUserIDs(state : any, specialtyId: number) {
            console.log("fetchAvailableSpecialistsUserIDs");
            
            
            // Remove hyphens from the date string
            
            console.log(process.env.BASE_URL + `api/vets/specialists/` + specialtyId.toString( ));

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/specialists/` + specialtyId.toString( ),
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_user_ids_data) => {
                        console.log("vet_user_ids_data", vet_user_ids_data);
                        console.log(typeof (vet_user_ids_data));
                        state.commit('setAvailableVetsUserIDs', vet_user_ids_data)
                        resolve(vet_user_ids_data)
                    })
                    .catch(err => reject(err))
            }))
        }
    }
}

const editedAvailabilityConfigResetState = () => ({
    editedAvailabilityConfigData:
    {
        id: 0,
        name: '',
        durationMinutes: 0,
        availabilityStep: 0,
        timeAvailableFor: 'P10W',
        subject: '',
        description: 'Vet appointments',
        location: 'Jitsi video call',
        workHours:
        {
            timezone: 'GMT',
            daySchedules: [{"dayOfWeek": "monday", "workingIntervals": []}],
        },
        availabilityIntervals : 
        {
            intervals : []
        },
        context: '',
        startConference: true
    },

    timeLimits: [] as string[],
    /*creatingAvailabilityConfig: false*/
});

export const editedAvailabilityConfig = {
    state: editedAvailabilityConfigResetState(),

    getters: {
        getEditedAvailabilityConfigData(state: any): AvailabilityConfig {
            return (state.editedAvailabilityConfigData)
        },

        getEditedDaySchedules(state: any): DaySchedule[] {
            return (state.editedAvailabilityConfigData.workHours.daySchedules.slice())
        },
        
        getAvailabilityIntervals(state: any): AvailabilityInterval[] {
            return (state.editedAvailabilityConfigData.availabilityIntervals.intervals.slice())
        },

        getTimeLimits(state: any): string[] {
            return (state.timeLimits)
        },
        
        getAvailabilityWeeks(state: any, getters: any): AvailabilityWeek[]
        {
            console.log("getAvailabilityWeeks");
            const weeks: AvailabilityWeek[] = [];
            const currentDate = new Date();
            console.log("currentDate", currentDate);

            // Helper function to format a Date as yyyy-mm-dd. Old version that doesn't work with time daylight saving changes
            /*
            const formatDate = (date: Date): string => {
                return date.toISOString().split('T')[0];
            };
            */

            // Helper function to format a Date as yyyy-mm-dd. New version that works with time daylight saving changes
            const formatDate = (date: Date): string => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Helper function to get the start of the week (e.g., Monday)
            const getStartOfWeek = (date: Date): Date => {
                const day = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                const diff = (day === 0 ? -6 : 1) - day; // Shift days to get Monday as start
                const start = new Date(date);
                start.setDate(date.getDate() + diff);
                start.setHours(0, 0, 0, 0); // Set time to midnight
                return start;
            };

            // Helper function to get the name of a day
            const getDayName = (date: Date): string => {
                const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                return daysOfWeek[date.getDay()];
            };

            const getISOWeekNumber = (date: Date): { year: number; week: number } => {
                const tempDate = new Date(date);
                tempDate.setHours(0, 0, 0, 0);
            
                // Align to nearest Thursday
                tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));
            
                // Find the ISO year
                const isoYear = tempDate.getFullYear();
            
                // January 4th is always in Week 1 of the ISO year
                const yearStart = new Date(isoYear, 0, 4);
                yearStart.setDate(yearStart.getDate() - ((yearStart.getDay() + 6) % 7));
            
                // Calculate the ISO week number
                const week = Math.ceil(((tempDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
            
                return { year: isoYear, week };
            };
            

            // Start iterating from the current week
            let startOfWeek = getStartOfWeek(currentDate);
            console.log("startOfWeek", startOfWeek);

            
            for (let week = 0; week < 10; week++) {
                const daysOfWeek: DayAvailability[] = [];

                for (let day = 0; day < 7; day++) {
                    const date = new Date(startOfWeek.getTime() + day * 86400000); // Safely shift by days
                    let dateStr = formatDate(date);
                    
                    // Use the getter to get the availability intervals
                    const availabilityIntervals = getters.getAvailabilityIntervals;  // Access the getter
                    const dayAvailability = availabilityIntervals.find(
                        (element: any) => element.dateStartInclusive === dateStr
                    );
                    daysOfWeek.push({
                        date: dateStr,
                        name: getDayName(date),
                        hours: dayAvailability ? dayAvailability.hours : []
                    });
                }

                // Calculate ISO year and week number
                const { year, week: isoWeek } = getISOWeekNumber(startOfWeek);


                weeks.push({
                    number: parseInt(`${year}${String(isoWeek).padStart(2, '0')}`), // Format as yyyynn
                    date_start: formatDate(startOfWeek), // First day of the week
                    date_end: formatDate(new Date(startOfWeek.getTime() + 6 * 86400000)), // Add 6 days
                    week_availability: daysOfWeek                   // All 7 days with dates and names
                });

                // Move to the next week without mutating the original date
                startOfWeek = new Date(startOfWeek.getTime() + 7 * 86400000); // Safely shift by 7 days
            }
            
            return weeks;
        }
    },
    mutations: {

        setEditedAvailabilityConfigData(state: any, availabilityConfigData: any) {

            state.editedAvailabilityConfigData = availabilityConfigData
        },

        /* Old version - several profiles
        setEditedDaySchedules(state: any, editedDaySchedules: any) {
            console.log("setEditedDaySchedules");
            console.log(editedDaySchedules);
            console.log(typeof (editedDaySchedules));
            state.editedAvailabilityConfigData.workHours = Object.assign({}, state.editedAvailabilityConfigData.workHours, { daySchedules: editedDaySchedules })
        },
        */
        
        // New version - unique profile
        setEditedDaySchedules(state: any, editedDaySchedules: any) {
            console.log("setEditedDaySchedules");
            console.log(editedDaySchedules);
            console.log(typeof (editedDaySchedules));
            // find the entry in intervals that has the same date as the editedDaySchedules
            // and update the hours
            let intervals = state.editedAvailabilityConfigData.availabilityIntervals.intervals
            // find the index of the interval that has the same dateStartInclusive as the editedDaySchedules
            let index = intervals.findIndex((element: any) => element.dateStartInclusive === editedDaySchedules[0].dateStartInclusive)
            // update the hours of the interval
            intervals[index].hours = editedDaySchedules[0].hours
            // update the state
            state.editedAvailabilityConfigData.availabilityIntervals.intervals = intervals         
        },

        setTimeLimits(state: any, newTimeLimits: string[]) {
            state.timeLimits = newTimeLimits
        },
        editedAvailabilityConfigResetStateMut(state: any) {
            Object.assign(state, editedAvailabilityConfigResetState())
        },
        
    },
    actions: {

        async iniEditedAvailabilityConfig(state: any, {vetId, aurinkoProfileId} : {vetId: number, aurinkoProfileId: number})
        {
            console.log("iniEditedAvailabilityConfig");
            
            try {
                const response = await fetch(process.env.BASE_URL + `api/vets/availability/${vetId}/${aurinkoProfileId}`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch availability configuration data');
                }

                const availabilityConfig = await response.json();
                console.log(availabilityConfig);
                state.commit('setEditedAvailabilityConfigData', availabilityConfig);

                return availabilityConfig; // Resolve the promise with the fetched availability configuration data
            } catch (error) {
                console.error('Error fetching availability configuration data:', error);
                throw error; // Re-throw the error to be caught by the caller
            }
        },
        
        async iniEditedAvailabilityConfigTimeLimits(state: any) {

            console.log("iniEditedAvailabilityConfigTimeLimits")

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/time-limits`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((time_limits) => {
                        console.log(time_limits);
                        state.commit('setTimeLimits', time_limits)
                        resolve(time_limits)
                    })
                    .catch(err => reject(err))
            }))

        },
        updateEditedDaySchedules(state: any, editedDaySchedules: DaySchedule[]) {
            console.log("updateEditedDaySchedules")
            console.log(editedDaySchedules)
            state.commit('setEditedDaySchedules', editedDaySchedules)
        },

        async updateVetAvailabilityProfile(state: any, {vetId, updatedAvailabilityProfile} : {vetId: number, updatedAvailabilityProfile: AvailabilityConfig} )
        {

            const response = await fetch(process.env.BASE_URL + `api/vets/availability/${vetId}/${updatedAvailabilityProfile.id}`,
            {
                method: 'PATCH',
                body: JSON.stringify(updatedAvailabilityProfile),
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            })

            if (response.ok) {
                return response.json
            } else {
                throw new Error('error_updating_availability_profile')
            }
        }
        
    }
}
